import Link from "next/link";
import { translateFunc } from "@/utils/translateFunc";
import { RouteNames } from "@/RouteNames";
import { useRouter } from "next/router";
import { useMobileNavigationMenu } from "../../../MobileNavigation/MobileNavigation";

export const MobileLoginNavLink = () => {
    const router = useRouter();
    const { closeModal } = useMobileNavigationMenu();
    return (
        <div className="p-5 flex flex-col gap-2 items-stretch border-b-slate-200 border-b dark:border-b-darkSurface-300">
            <Link
                href={
                    router.pathname === RouteNames.loginRoute || router.pathname === "/"
                        ? RouteNames.loginRoute
                        : `${RouteNames.loginRoute}?redirect=${router.asPath}`
                }
                onClick={closeModal}
                className="border-[1px] border-gray-300 dark:border-white dark:text-white rounded-md px-4 py-1 capitalize whitespace-nowrap text-center"
            >
                {translateFunc("common:login")}
            </Link>
            <Link
                href={RouteNames.pricing}
                onClick={closeModal}
                className="border-[1px] bg-irBlue-600 border-irBlue-600 text-white rounded-md px-4 py-1 capitalize whitespace-nowrap text-center"
            >
                {translateFunc("common:signup")}
            </Link>
        </div>
    );
};
